import React from 'react';
import PropTypes from 'prop-types';
import KpiTable from '../../../commons/KpiTable';

const StudentAccessFrequencyTable = (props) => (
  <KpiTable
    title="Access count"
    description="The amount of days that  students that studied at least once accessed the system."
    loading={props.loading}
    values={props.values}
    currentHigherIsBetter={false}
    onSelect={props.onSelect}
    formatter={props.formatter}
    feedbackColorRender={props.feedbackColorRender}
    additionalColumns={[
      {
        label: 'Standard Deviation',
        path: 'currentStandardDeviation',
      },
      {
        label: 'Total of Registers',
        path: 'currentAmount',
      },
    ]}
  />
);

StudentAccessFrequencyTable.propTypes = {
  onSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func.isRequired,
};

export default StudentAccessFrequencyTable;
